import { render, staticRenderFns } from "./ConfigCreditAnalysisAba.vue?vue&type=template&id=327faca4&scoped=true&"
import script from "./ConfigCreditAnalysisAba.vue?vue&type=script&lang=js&"
export * from "./ConfigCreditAnalysisAba.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCreditAnalysisAba.vue?vue&type=style&index=0&id=327faca4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327faca4",
  null
  
)

export default component.exports